import styled from "styled-components/macro";

export const StyledContainer = styled.div`
  /* background: white; */
  text-align: center;
  font-family: "GT Super Text";
  padding: 40px 15px;

  h1 {
    font-size: 20px;
    line-height: 25px;
    font-family: "GT Super Text";
    margin: 0 auto 15px auto;
    text-align: center;
  }

  p {
    color: #333;
    font-size: 14px;
    line-height: 17px;
    margin-bottom: 15px;
  }

  small {
    display: block;
    color: #999;
    font-family: "Inter";
    font-size: 10px;
    max-width: 300px;
    margin: 0 auto 25px auto;
    line-height: 13px;

    a {
      color: #999;
      text-decoration: underline;
    }
  }

  .error {
    color: red;
    font-size: 13px;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .google {
    font-weight: 500;
    background: white;
    font-family: "Inter";
    border: 2px solid #2a2315;
    border-radius: 7px;
    padding: 10px 4px;
    width: 300px;
    font-size: 16px;
    line-height: 22px;
    cursor: pointer;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;

    img {
      width: 22px;
      height: 22px;
      vertical-align: middle;
      margin-right: 12px;
      position: relative;
      top: -2px;
    }
  }

  .or {
    font-size: 16px;
    font-family: "Inter";
    color: #888;
    margin: 10px auto;
  }

  input {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    border-radius: 7px;
    border: 2px solid #2a2315;
    padding: 10px 8px;
    width: 300px;
    font-size: 16px;
    font-family: "Inter";
    background: white;
    margin-bottom: 15px;

    &:focus {
      font-weight: 500;
      border: 2px solid #30ab66;
      outline: 2px solid #30ab66;
    }
  }

  .email-button {
    font-weight: 500;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    border-radius: 7px;
    border: 0 solid #2a2315;
    padding: 10px 8px;
    width: 300px;
    font-size: 16px;
    font-family: "Inter";
    background: #30ab66;
    color: white;
    cursor: pointer;

    &:disabled {
      opacity: 0.7;
    }
  }
`;
